export default "__VITE_ASSET__6f791953__"